import { useEffect, useState, useRef } from 'react';
import { getJumpCfg } from '@/api/modules/openWeapp';
import { GetJumpCfgRes, GenerateUrlRes } from '@/api/interface/openWeapp';
import classNames from 'classnames';
import { useParams, useSearchParams } from 'react-router-dom';
import back from '@/images/transfer/back.png';
import style from './index.module.scss';
import {
  goWechatCustom,
  getSysEnv,
  compareVersions,
  setDocumentTitle,
} from '@/utils';
import { ENV_VERSION } from '@/utils/pathConfig';
import { Empty } from '@/components/Empty';
import { Toast } from 'antd-mobile';
import {
  isHdl,
  isHarmonyOS,
  commonBridge,
  HRouter,
} from '@haidilao-private/jsbridge';
import { ERROR_TYPR, WX_CHAT, URL_LINK_API } from './config';
const { REACT_APP_API_ENV = 'pro' } = process.env;
interface APPInformationProps {
  APPVersion?: string;
  phoneVersion?: string;
  systemVersion?: string;
}

const TransferLd = () => {
  const params = useParams();
  /**判断系统环境 */
  const sysEnv = getSysEnv();
  /**页面报错类型 */
  const [errortype, setErrortype] = useState('');
  /**小程序跳转链接 */
  const urlLink = useRef('');
  /**微信内跳转标签 */
  const btnBoxRef = useRef(null);
  /**页面配置信息 */
  const [detail, setDetail] = useState<Partial<GetJumpCfgRes>>({});
  /**是否是鸿蒙老版本,老版本保持不变，显示缺省页 */
  const [isHarmonyOSOld, setIsHarmonyOSOld] = useState<boolean>();
  const [searchParams] = useSearchParams();
  // 获取 abc 参数
  const isHiddenAppNav = searchParams.get('hidden');

  useEffect(() => {
    console.log(
      '-----------------浏览器环境-----------------',
      navigator.userAgent
    );
    //app中设置标题，微信中走公共设置标题
    setTimeout(() => {
      if (isHdl) setDocumentTitle('跳转小程序');
    }, 300);
    //鸿蒙app内环境
    if (isHdl && isHarmonyOS) {
      //如果是新版本，不显示缺省页，老版本 还是保持缺省页
      commonBridge(
        'webGetAPPInformation',
        {},
        (res: APPInformationProps | null) => {
          // 1是新版本  2是版本相等  3是旧版本
          if (Number(compareVersions('8.8.0', res?.APPVersion || '')) < 3) {
            setIsHarmonyOSOld(false);
            init();
          } else {
            setIsHarmonyOSOld(true);
          }
        }
      );
    } else {
      //其他环境
      setIsHarmonyOSOld(false);
      init();
    }
  }, [window.location.href]);

  /**
   * 初始化
   */
  const init = async () => {
    try {
      //pc端不显示
      if (sysEnv === 'isDesktop') return;
      // 没有链接id不显示
      if (!params.id) return setErrortype('error');

      const { jumpUrl, wxAppId, jumpUrlWx }: GetJumpCfgRes = await getDetail();

      //没有appid 和跳转链接不显示
      if (!wxAppId || !jumpUrl) {
        setErrortype('error');
        return;
      }
      if (sysEnv === 'isMobile') {
        // 在手机 其他环境的浏览器 需要去拿小程序的url-link地址
        getUrlLink(jumpUrlWx, wxAppId);
      } else if (sysEnv === 'isWeixin') {
        // 微信 内部浏览器
        const _wxIds = WX_CHAT[wxAppId];
        if (!_wxIds) {
          setErrortype('error');
          return;
        }
        let _jumpUrl = jumpUrl;
        try {
          if (_jumpUrl.indexOf('?') > -1) {
            _jumpUrl = `${_jumpUrl}&active_page_id=${encodeURIComponent(
              params.id || ''
            )}`;
          } else {
            _jumpUrl = `${_jumpUrl}?active_page_id=${encodeURIComponent(
              params.id || ''
            )}`;
          }
        } catch (err) {
          console.log('err', err);
        }
        setTimeout(() => {
          goWechatCustom(btnBoxRef, _wxIds, _jumpUrl);
        }, 500);
      }
    } catch (err) {
      console.log('init-err', err);
      throw err;
    }
  };
  /**
   * 获取页面详情
   */
  const getDetail = async () => {
    try {
      const res = (await getJumpCfg({
        id: decodeURIComponent(params.id || ''),
      })) as GetJumpCfgRes;
      let _jumpUrl = '';
      let _jumpUrlWx: string[] = [];

      if (res?.jumpUrl?.indexOf('?params?') > -1) {
        // 兼容老版本?params?
        _jumpUrl = res?.jumpUrl?.replace('?params?', '?');
        _jumpUrlWx = res?.jumpUrl?.split('?params?');
      } else {
        _jumpUrl = res?.jumpUrl;
        _jumpUrlWx = res?.jumpUrl?.split('?');
      }

      const _detail = {
        ...res,
        jumpUrl: _jumpUrl,
        jumpUrlWx: _jumpUrlWx,
      };
      setDetail(_detail);
      return Promise.resolve(_detail);
    } catch (err) {
      setErrortype('error');
      return Promise.reject(err);
    }
  };

  /**
   * 获取小程序URL-LINK
   */
  const getUrlLink = async (jumpUrlWx: string[], wxAppId: string) => {
    try {
      const KEY = `openWeapp_${WX_CHAT[wxAppId]}_${params.id}`;
      console.log(KEY);
      //如果缓存中有，取缓存里面的
      if (localStorage.getItem(KEY)) {
        urlLink.current = localStorage.getItem(KEY) || '';
        initMobild();
        return;
      }
      //清空所有缓存
      clearLocalStorageByRegex(/^openWeapp_/);
      //query参数中增加活动id
      let _query = jumpUrlWx[1];
      try {
        const _actid = `active_page_id=${encodeURIComponent(params.id || '')}`;
        _query = _query ? `${_query}&${_actid}` : _actid;
      } catch (err) {
        console.log('err', err);
      }

      const res = (await URL_LINK_API[wxAppId]({
        path: jumpUrlWx[0],
        query: _query,
        env_version: ENV_VERSION,
      })) as GenerateUrlRes;
      if (Number(res.errcode) === 0) {
        urlLink.current = res.url_link;
        //存储url-link key:openWeapp_原始id_页面id 防止重复
        localStorage.setItem(KEY, res.url_link);
        initMobild();
      } else {
        setErrortype('error');
      }
    } catch (err) {
      setErrortype('error');
    }
  };

  /**
   * 手机浏览器打开
   */
  const initMobild = async () => {
    if (!urlLink.current) return;
    if (!isHdl) {
      location.href = urlLink.current;
    }
  };

  /**
   * 打开小程序
   */
  const openWeapp = async () => {
    if (isHdl) {
      onTransfer();
    } else if (sysEnv === 'isMobile') {
      // 在手机 其他环境的浏览器
      initMobild();
    }
  };

  /**
   * app内打开小程序
   */
  const onTransfer = () => {
    if (!detail.wxAppId || !WX_CHAT[detail.wxAppId]) return;
    commonBridge(
      'webGetAPPInformation',
      {},
      (res: APPInformationProps | null) => {
        if (Number(compareVersions('8.3.0', res?.APPVersion || '')) < 3) {
          commonBridge('launchMiniprogram', {
            path: detail.jumpUrl,
            userName: detail.wxAppId ? WX_CHAT[detail.wxAppId] : '',
            miniprogramType: REACT_APP_API_ENV == 'pro' ? '0' : '2',
          });
        } else {
          Toast.show({
            content: '此版本无法支持该功能，请更新到最新版本',
          });
        }
      }
    );
  };

  /**
   * 清除匹配的localstorage
   */
  const clearLocalStorageByRegex = (regex: RegExp) => {
    Object.keys(localStorage).forEach((key: string) => {
      if (regex.test(key)) {
        localStorage.removeItem(key);
      }
    });
  };

  const onBack = () => {
    HRouter.back();
  };

  return isHarmonyOSOld && isHdl ? (
    /* 鸿蒙 */
    <Empty
      icon={require('@/images/common/icon_noopen.png')}
      title="暂不支持鸿蒙系统跳转"
    />
  ) : (
    <div className={style.open_weapp}>
      {isHdl && isHiddenAppNav == '1' ? (
        <div className={style.backBox} onClick={onBack}>
          <img className={style.backs} src={back} />
        </div>
      ) : null}
      {errortype ? (
        // 报错页面
        <Empty
          icon={ERROR_TYPR[errortype].icon}
          title={ERROR_TYPR[errortype].title}
        />
      ) : (
        // 正常页面
        <div className={style.open_weapp_container}>
          {/* pc */}
          {sysEnv === 'isDesktop' && (
            <Empty
              icon={require('@/images/common/icon_noopen.png')}
              title="暂不支持PC端打开"
            />
          )}
          {/* 手机 */}
          {(sysEnv === 'isMobile' || sysEnv === 'isWeixin') && (
            <div className={style.isMobile}>
              <div className={style.mobileContent}>
                {detail?.imgUrl && (
                  <img
                    className={style.transferImg}
                    src={detail?.imgUrl}
                    alt=""
                  />
                )}
                <div className={style.transferbtn} onClick={openWeapp}>
                  <span
                    ref={btnBoxRef}
                    className={classNames(style.transferbtnwx, 'OPEN_WEAPP')}
                  ></span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default TransferLd;
